import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Badge, Button, Table, Progress } from "reactstrap";
import "../../assets/css/--page-account-favorites.css";
import { useNavigate } from "react-router-dom";
import burgerImg from "../../assets/images/burgerImg.png";
import fireImg from "../../assets/images/fireImg.png";
import { addWishlist, getWishList } from "../../helper/backend-methods";
import ProductCustomizationModal from "../../components/ProductCustomizationModal";
import { GlobalContext } from "../../context";
import { addCart } from "../../helper/backend-methods";
import { customToast } from "../../components/customToast";
import noOrder from "../../assets/images/no-order.png";
import AppLoader from "../../components/AppLoader";

function Favorites() {
  const history = useNavigate();
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { updateCartCount, addProductsToCart, updateCartDrawer } = useContext(GlobalContext);

  const getFavouriteList = () => {
    getWishList()
      .then(({ data }) => {
        if (data.Status) {
          setFavorites(data.Data.WishlistItems);
        }
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };

  const removeFavourite = (selectedProductId) => {
    addWishlist({ Add: false, ProductId: selectedProductId })
      .then(({ data }) => {
        if (data.Status) {
          setFavorites((prev) => prev.filter((item) => item.ProductId !== selectedProductId));
        }
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };

  const addToCart = (item) => {
    addProductsToCart(item);
  };

  useEffect(() => {
    getFavouriteList();
  }, []);

  const handleProductClick = (product) => {
    const hasCustomizations = product.productAttributes && product.productAttributes.length > 0;

    const productWithDefaults = {
      ...product,
      SelectedAddons: [],
      totalPrice: product.Price || 0,
    };

    if (hasCustomizations) {
      setSelectedProduct(productWithDefaults);
      setIsModalOpen(true);
    } else {
      addCart({
        Products: [
          {
            ProductId: product.Id,
            Quantity: 1,
            AttributesXml: null,
          },
        ],
      })
        .then(({ data }) => {
          if (data.Status) {
            customToast.success("Added to Cart", "Your item has been successfully added.", "/openCart");
            updateCartCount({
              CartItemCount: data.Data.CartItemCount,
              TotalAmount: data.Data.TotalAmount,
            });
            updateCartDrawer();
          }
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);
          customToast.error("Error", "Failed to add item to cart.");
        });
    }
  };

  return (
    <div className="mt-5 ms-4">
      <div className="order-heading d-flex align-items-center justify-content-between mb-4">
        <h1 className="fs-30 text-blakish fw-600 m-0">Your Favorites</h1>
        <button onClick={() => history("/menu")} className="explore-menu-btn">
          EXPLORE MENU
        </button>
      </div>
      <span className="separator mt-4 mb-5"></span>
      <div className="fav-container">
        {loading ? (
          <div className="loader-center">
            <AppLoader />
          </div>
        ) : favorites.length > 0 ? (
          <Row className="favorite-cards">
            {favorites.map((item) => (
              <Col md={6} lg={6} xl={6} className="mb-4 favorite-card-container" key={item.id}>
                <div className="favorite-card">
                  <div className="card-header-section">
                    {item.IsTodaySpecial ? (
                      <div className="special-badge fs-18 fw-600 text-blakish">
                        <img src={fireImg} alt="fire imgs" /> Today's Special
                      </div>
                    ) : (
                      ""
                    )}
                    <button className="heart-btn" onClick={() => removeFavourite(item.ProductId)}>
                      <i className="ri-heart-fill"></i>
                    </button>
                  </div>

                  <div className="card-content mb-3">
                    <div className="card-text">
                      <h6 className="item-title text-blakish fs-22 fw-700">{item.Product.Name}</h6>
                      <p className="item-desc text-gray fs-18 fw-400 mb-0" title={item?.Product?.ShortDescription || ""}>
                        {item?.Product?.ShortDescription
                          ? item.Product.ShortDescription.length > 80
                            ? item.Product.ShortDescription.slice(0, 80) + "..."
                            : item.Product.ShortDescription
                          : ""}
                      </p>
                    </div>
                    <div className="card-image">
                      <img src={item.Product.PicturURL} alt={item.title} />
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="item-price fw-600 fs-20">${item.Product.Price}</div>
                    <div className="card-image">
                      <button className="add-btn" onClick={() => handleProductClick(item.Product)}>
                        <i className="ri-add-line text-white fs-20"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        ) : (
          <div className="d-flex flex-column justify-content-center align-items-center flex-wrap text-center mt-5 pt-5">
            <img src={noOrder} alt="" />
            <h2 className="fs-36 fw-600 text-blakish mt-4">Looks like you don’t have any favorites yet</h2>
            <p className="fs-18 fw-600 text-blakish mt-2">
              Once you add a favorite, it will show up here for easy reordering <br />
              and quick access.
            </p>
          </div>
        )}
      </div>
      <ProductCustomizationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        product={selectedProduct}
        toastLink="/openCart"
        />
      </div>
  );
}

export default Favorites;
